<app-modal-header title="Two-factor authentication enabled" />

<app-modal-body>
  <p class="two-factor-setup__hint">Save these backup codes somewhere safe. Each one can be used once to sign in if you lose access to your authenticator app. They won't be shown again.</p>

  <ol class="backup-codes" aria-label="Backup codes">
    @for (code of data().codes; track $index) {
      <li class="backup-codes__item">
        <span class="backup-codes__index" aria-hidden="true">{{ $index + 1 }}</span>
        <code class="backup-codes__code">{{ code }}</code>
      </li>
    }
  </ol>

  <div class="backup-codes__actions">
    <button type="button" class="btn--secondary" data-modal-autofocus (click)="copy()">Copy codes</button>
    <button type="button" class="btn--secondary" (click)="download()">Download</button>
  </div>

  <label class="backup-codes__confirm">
    <input type="checkbox" [formControl]="saved" />
    <span>I've saved these backup codes</span>
  </label>
</app-modal-body>

<app-modal-footer>
  <button type="button" class="btn--primary" [disabled]="!saved.value" (click)="modalRef.close()">Done</button>
</app-modal-footer>
